const RouterRedirect = () => import( /* webpackChunkName: "open-shop" */ 'viralstyle-ui/src/VsRouterRedirect');

const Marketplace = () => import( /* webpackChunkName: "marketplace" */ './Marketplace');

export default {
  path: '/marketplace',
  component: RouterRedirect,
  redirect: '/marketplace/1',
  name: 'marketplaceRoot',
  children: [{
    path: '/marketplace/:page',
    name: 'marketplace',
    component: Marketplace,
    props: true,
  }, ],
};